// 튜토리얼 훅

import { useEffect, useState } from "react"
import { checkTutorial, logTutorial } from "../api/tutorial"

export const useTutorial = (page) => {
  // null: 아직 서버 응답 전
  // true: 튜토리얼 보여줌
  // false: 튜토리얼 안 보여줌
  const [show, setShow] = useState(null)

  // 튜토리얼 여부 체크
  useEffect(() => {
    const fetchTutorialState = async() => {
      try {
        const res = await checkTutorial(page);
       // 튜토리얼을 봤으면 열지 않기
        if (res.doTutorial) {
          setShow(false);
        } else {
          setShow(true);
        }
      } catch (err) {
        setShow(false);
      }
    }
    fetchTutorialState();
  }, [page])

  // 튜토리얼 완료
  const complete = async() => {
    try {
      await logTutorial(page);
    } catch (err) {
      // console.log(err);
      console.error(err);
    } finally {
      setShow(false)
    }
  }

  return { show, complete }
}